import { useEffect, useState } from 'react';
import { useRecordContext } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { FCRAWorker, OneOffCheckRecord } from '@/types/turn-api';
import { TurnResourcesEnum } from '@/types/turn-enums';

const useController = () => {
  const worker: FCRAWorker.Details = useRecordContext();
  const { runRequest } = useRunRequest();
  const [checks, setChecks] = useState<OneOffCheckRecord.Base[]>([]);
  const [record, setRecord] = useState<OneOffCheckRecord.Base | null>(null);
  const [showForm, setShowForm] = useState(false);

  const getChecks = async () => {
    const response = await runRequest({
      fetchType: 'GET_LIST',
      resource: TurnResourcesEnum.OneOffChecks,
      params: {},
      mode: 'silent',
    });

    setChecks(response.data);
  };

  useEffect(() => {
    getChecks();
  }, []);

  const openForm = () => setShowForm(true);

  const closeForm = () => {
    setShowForm(false);
    setRecord(null);
  };

  const handleOnEdit = (record: OneOffCheckRecord.Base) => {
    setRecord(record);
    openForm();
  };

  return {
    checks,
    closeForm,
    handleOnEdit,
    openForm,
    record,
    setRecord,
    showForm,
    worker,
  };
};

export default useController;
